import {
  Companion_getInstance1moufct3sbct9 as Companion_getInstance,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { CompletionResponseSerializable2r3u7efewr7mg as CompletionResponseSerializable } from './completionResponse/serialization.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lineItem(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItemCompletionMessage_lineItem_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItemCompletionMessage_created_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItemCompletionMessage_project_getInstance());
}
function prepareLineItemCompletionMessageFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [LineItemCompletionMessage__id_getInstance(), LineItemCompletionMessage_project_getInstance(), LineItemCompletionMessage_lineItem_getInstance(), LineItemCompletionMessage_sender_getInstance(), LineItemCompletionMessage_clientMessage_getInstance(), LineItemCompletionMessage_responseTypeSerializable_getInstance(), LineItemCompletionMessage_message_getInstance(), LineItemCompletionMessage_attachments_getInstance(), LineItemCompletionMessage_created_getInstance(), LineItemCompletionMessage_readBy_getInstance(), LineItemCompletionMessage_needsResponse_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function LineItemCompletionMessage_lineItem$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function LineItemCompletionMessage_lineItem$_get_name_$ref_uha1gx() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_lineItem$_get_serializer_$ref_xpdsl2() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function LineItemCompletionMessage_lineItem$_get_annotations_$ref_4i44ze() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_lineItemClass;
function LineItemCompletionMessage_lineItem() {
  if (LineItemCompletionMessage_lineItemClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_lineItem_instance = this;
        var tmp = this;
        tmp.s6g_1 = lazy(LineItemCompletionMessage_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t6g_1 = lazy(LineItemCompletionMessage_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u6g_1 = lazy(LineItemCompletionMessage_lineItem$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.s6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_lineItem$_get_name_$ref_uha1gx(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.y6g_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      i6h(receiver, value) {
        return receiver.j6h(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.i6h(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_lineItem$_get_serializer_$ref_xpdsl2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_lineItem$_get_annotations_$ref_4i44ze(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_lineItem', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_lineItemClass = $;
  }
  return LineItemCompletionMessage_lineItemClass;
}
var LineItemCompletionMessage_lineItem_instance;
function LineItemCompletionMessage_lineItem_getInstance() {
  if (LineItemCompletionMessage_lineItem_instance === VOID)
    new (LineItemCompletionMessage_lineItem())();
  return LineItemCompletionMessage_lineItem_instance;
}
function LineItemCompletionMessage_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function LineItemCompletionMessage_created$_get_name_$ref_idg93u() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_created$_get_serializer_$ref_3xeerj() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function LineItemCompletionMessage_created$_get_annotations_$ref_ymll7p() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_createdClass;
function LineItemCompletionMessage_created() {
  if (LineItemCompletionMessage_createdClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_created_instance = this;
        var tmp = this;
        tmp.k6h_1 = lazy(LineItemCompletionMessage_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l6h_1 = lazy(LineItemCompletionMessage_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m6h_1 = lazy(LineItemCompletionMessage_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.n6h_1 = get_default(Companion_instance).b1m();
        this.o6h_1 = 'now()';
      }
      i20() {
        var tmp0 = this.k6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_created$_get_name_$ref_idg93u(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.e6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      p6h(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.p6h(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_created$_get_serializer_$ref_3xeerj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_created$_get_annotations_$ref_ymll7p(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_created', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_createdClass = $;
  }
  return LineItemCompletionMessage_createdClass;
}
var LineItemCompletionMessage_created_instance;
function LineItemCompletionMessage_created_getInstance() {
  if (LineItemCompletionMessage_created_instance === VOID)
    new (LineItemCompletionMessage_created())();
  return LineItemCompletionMessage_created_instance;
}
function LineItemCompletionMessage_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function LineItemCompletionMessage_project$_get_name_$ref_e46hrf() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_project$_get_serializer_$ref_4o6lri() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function LineItemCompletionMessage_project$_get_annotations_$ref_dc8fsa() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_projectClass;
function LineItemCompletionMessage_project() {
  if (LineItemCompletionMessage_projectClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_project_instance = this;
        var tmp = this;
        tmp.q6h_1 = lazy(LineItemCompletionMessage_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r6h_1 = lazy(LineItemCompletionMessage_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s6h_1 = lazy(LineItemCompletionMessage_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.q6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_project$_get_name_$ref_e46hrf(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.x6g_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      i6h(receiver, value) {
        return receiver.j6h(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.i6h(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_project$_get_serializer_$ref_4o6lri(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_project$_get_annotations_$ref_dc8fsa(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_project', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_projectClass = $;
  }
  return LineItemCompletionMessage_projectClass;
}
var LineItemCompletionMessage_project_instance;
function LineItemCompletionMessage_project_getInstance() {
  if (LineItemCompletionMessage_project_instance === VOID)
    new (LineItemCompletionMessage_project())();
  return LineItemCompletionMessage_project_instance;
}
function LineItemCompletionMessage__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function LineItemCompletionMessage__id$_get_name_$ref_ikf830() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage__id$_get_serializer_$ref_76xqkz() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function LineItemCompletionMessage__id$_get_annotations_$ref_pzesnd() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage__idClass;
function LineItemCompletionMessage__id() {
  if (LineItemCompletionMessage__idClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage__id_instance = this;
        var tmp = this;
        tmp.t6h_1 = lazy(LineItemCompletionMessage__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6h_1 = lazy(LineItemCompletionMessage__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6h_1 = lazy(LineItemCompletionMessage__id$annotations$delegate$lambda);
        this.w6h_1 = Companion_getInstance_0().k2p();
        this.x6h_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.t6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage__id$_get_name_$ref_ikf830(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.w6g_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      i6h(receiver, value) {
        return receiver.j6h(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.i6h(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage__id$_get_serializer_$ref_76xqkz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage__id$_get_annotations_$ref_pzesnd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage__id', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage__idClass = $;
  }
  return LineItemCompletionMessage__idClass;
}
var LineItemCompletionMessage__id_instance;
function LineItemCompletionMessage__id_getInstance() {
  if (LineItemCompletionMessage__id_instance === VOID)
    new (LineItemCompletionMessage__id())();
  return LineItemCompletionMessage__id_instance;
}
function LineItemCompletionMessage_sender$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function LineItemCompletionMessage_sender$_get_name_$ref_f8d9r1() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_sender$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_sender$_get_serializer_$ref_ccgg78() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_sender$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function LineItemCompletionMessage_sender$_get_annotations_$ref_rctb48() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_senderClass;
function LineItemCompletionMessage_sender() {
  if (LineItemCompletionMessage_senderClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_sender_instance = this;
        var tmp = this;
        tmp.y6h_1 = lazy(LineItemCompletionMessage_sender$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z6h_1 = lazy(LineItemCompletionMessage_sender$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a6i_1 = lazy(LineItemCompletionMessage_sender$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.y6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_sender$_get_name_$ref_f8d9r1(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.z6g_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      i6h(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.i6h(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_sender$_get_serializer_$ref_ccgg78(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_sender$_get_annotations_$ref_rctb48(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_sender', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_senderClass = $;
  }
  return LineItemCompletionMessage_senderClass;
}
var LineItemCompletionMessage_sender_instance;
function LineItemCompletionMessage_sender_getInstance() {
  if (LineItemCompletionMessage_sender_instance === VOID)
    new (LineItemCompletionMessage_sender())();
  return LineItemCompletionMessage_sender_instance;
}
function LineItemCompletionMessage_clientMessage$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function LineItemCompletionMessage_clientMessage$_get_name_$ref_5oz2r2() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_clientMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_clientMessage$_get_serializer_$ref_1zw0bv() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_clientMessage$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function LineItemCompletionMessage_clientMessage$_get_annotations_$ref_p88u9z() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_clientMessageClass;
function LineItemCompletionMessage_clientMessage() {
  if (LineItemCompletionMessage_clientMessageClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_clientMessage_instance = this;
        var tmp = this;
        tmp.b6i_1 = lazy(LineItemCompletionMessage_clientMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c6i_1 = lazy(LineItemCompletionMessage_clientMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d6i_1 = lazy(LineItemCompletionMessage_clientMessage$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_clientMessage$_get_name_$ref_5oz2r2(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.a6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      e6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.e6i(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_clientMessage$_get_serializer_$ref_1zw0bv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_clientMessage$_get_annotations_$ref_p88u9z(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_clientMessage', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_clientMessageClass = $;
  }
  return LineItemCompletionMessage_clientMessageClass;
}
var LineItemCompletionMessage_clientMessage_instance;
function LineItemCompletionMessage_clientMessage_getInstance() {
  if (LineItemCompletionMessage_clientMessage_instance === VOID)
    new (LineItemCompletionMessage_clientMessage())();
  return LineItemCompletionMessage_clientMessage_instance;
}
function LineItemCompletionMessage_responseTypeSerializable$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function LineItemCompletionMessage_responseTypeSerializable$_get_name_$ref_wvkv7m() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_responseTypeSerializable$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_responseTypeSerializable$_get_serializer_$ref_pqzru1() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_responseTypeSerializable$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function LineItemCompletionMessage_responseTypeSerializable$_get_annotations_$ref_x09fn7() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_responseTypeSerializableClass;
function LineItemCompletionMessage_responseTypeSerializable() {
  if (LineItemCompletionMessage_responseTypeSerializableClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_responseTypeSerializable_instance = this;
        var tmp = this;
        tmp.f6i_1 = lazy(LineItemCompletionMessage_responseTypeSerializable$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6i_1 = lazy(LineItemCompletionMessage_responseTypeSerializable$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6i_1 = lazy(LineItemCompletionMessage_responseTypeSerializable$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.f6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_responseTypeSerializable$_get_name_$ref_wvkv7m(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.b6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      i6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.i6i(tmp, value instanceof CompletionResponseSerializable() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_responseTypeSerializable$_get_serializer_$ref_pqzru1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_responseTypeSerializable$_get_annotations_$ref_x09fn7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_responseTypeSerializable', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_responseTypeSerializableClass = $;
  }
  return LineItemCompletionMessage_responseTypeSerializableClass;
}
var LineItemCompletionMessage_responseTypeSerializable_instance;
function LineItemCompletionMessage_responseTypeSerializable_getInstance() {
  if (LineItemCompletionMessage_responseTypeSerializable_instance === VOID)
    new (LineItemCompletionMessage_responseTypeSerializable())();
  return LineItemCompletionMessage_responseTypeSerializable_instance;
}
function LineItemCompletionMessage_message$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function LineItemCompletionMessage_message$_get_name_$ref_sw6von() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_message$_get_serializer_$ref_orsigw() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_message$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function LineItemCompletionMessage_message$_get_annotations_$ref_tidrp8() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_messageClass;
function LineItemCompletionMessage_message() {
  if (LineItemCompletionMessage_messageClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_message_instance = this;
        var tmp = this;
        tmp.j6i_1 = lazy(LineItemCompletionMessage_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k6i_1 = lazy(LineItemCompletionMessage_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l6i_1 = lazy(LineItemCompletionMessage_message$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.j6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_message$_get_name_$ref_sw6von(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.c6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      m6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.m6i(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_message$_get_serializer_$ref_orsigw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_message$_get_annotations_$ref_tidrp8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_message', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_messageClass = $;
  }
  return LineItemCompletionMessage_messageClass;
}
var LineItemCompletionMessage_message_instance;
function LineItemCompletionMessage_message_getInstance() {
  if (LineItemCompletionMessage_message_instance === VOID)
    new (LineItemCompletionMessage_message())();
  return LineItemCompletionMessage_message_instance;
}
function LineItemCompletionMessage_attachments$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function LineItemCompletionMessage_attachments$_get_name_$ref_gb1vtu() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_attachments$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_attachments$_get_serializer_$ref_yp4i6h() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_attachments$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function LineItemCompletionMessage_attachments$_get_annotations_$ref_q9vwgj() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_attachmentsClass;
function LineItemCompletionMessage_attachments() {
  if (LineItemCompletionMessage_attachmentsClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_attachments_instance = this;
        var tmp = this;
        tmp.n6i_1 = lazy(LineItemCompletionMessage_attachments$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o6i_1 = lazy(LineItemCompletionMessage_attachments$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p6i_1 = lazy(LineItemCompletionMessage_attachments$annotations$delegate$lambda);
        this.q6i_1 = emptyList();
        this.r6i_1 = 'emptyList()';
      }
      i20() {
        var tmp0 = this.n6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_attachments$_get_name_$ref_gb1vtu(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.d6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      s6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.s6i(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_attachments$_get_serializer_$ref_yp4i6h(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_attachments$_get_annotations_$ref_q9vwgj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_attachments', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_attachmentsClass = $;
  }
  return LineItemCompletionMessage_attachmentsClass;
}
var LineItemCompletionMessage_attachments_instance;
function LineItemCompletionMessage_attachments_getInstance() {
  if (LineItemCompletionMessage_attachments_instance === VOID)
    new (LineItemCompletionMessage_attachments())();
  return LineItemCompletionMessage_attachments_instance;
}
function LineItemCompletionMessage_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function LineItemCompletionMessage_readBy$_get_name_$ref_uowutn() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_readBy$_get_serializer_$ref_u4vlic() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function LineItemCompletionMessage_readBy$_get_annotations_$ref_5ay9eo() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_readByClass;
function LineItemCompletionMessage_readBy() {
  if (LineItemCompletionMessage_readByClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_readBy_instance = this;
        var tmp = this;
        tmp.t6i_1 = lazy(LineItemCompletionMessage_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6i_1 = lazy(LineItemCompletionMessage_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6i_1 = lazy(LineItemCompletionMessage_readBy$annotations$delegate$lambda);
        this.w6i_1 = emptySet();
        this.x6i_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.t6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_readBy$_get_name_$ref_uowutn(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.f6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      y6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.y6i(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_readBy$_get_serializer_$ref_u4vlic(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_readBy$_get_annotations_$ref_5ay9eo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_readBy', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_readByClass = $;
  }
  return LineItemCompletionMessage_readByClass;
}
var LineItemCompletionMessage_readBy_instance;
function LineItemCompletionMessage_readBy_getInstance() {
  if (LineItemCompletionMessage_readBy_instance === VOID)
    new (LineItemCompletionMessage_readBy())();
  return LineItemCompletionMessage_readBy_instance;
}
function LineItemCompletionMessage_needsResponse$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function LineItemCompletionMessage_needsResponse$_get_name_$ref_ph4wk0() {
  return (p0) => p0.i20();
}
function LineItemCompletionMessage_needsResponse$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemCompletionMessage_needsResponse$_get_serializer_$ref_uhp5m1() {
  return (p0) => p0.h2j();
}
function LineItemCompletionMessage_needsResponse$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function LineItemCompletionMessage_needsResponse$_get_annotations_$ref_5qi1rv() {
  return (p0) => p0.bz();
}
var LineItemCompletionMessage_needsResponseClass;
function LineItemCompletionMessage_needsResponse() {
  if (LineItemCompletionMessage_needsResponseClass === VOID) {
    class $ {
      constructor() {
        LineItemCompletionMessage_needsResponse_instance = this;
        var tmp = this;
        tmp.z6i_1 = lazy(LineItemCompletionMessage_needsResponse$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a6j_1 = lazy(LineItemCompletionMessage_needsResponse$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b6j_1 = lazy(LineItemCompletionMessage_needsResponse$annotations$delegate$lambda);
        this.c6j_1 = true;
        this.d6j_1 = 'true';
      }
      i20() {
        var tmp0 = this.z6i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemCompletionMessage_needsResponse$_get_name_$ref_ph4wk0(), null);
        return tmp0.f2();
      }
      v6g(receiver) {
        return receiver.g6h_1;
      }
      k2j(receiver) {
        return this.v6g(receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE());
      }
      e6i(receiver, value) {
        return receiver.j6h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItemCompletionMessage() ? receiver : THROW_CCE();
        return this.e6i(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemCompletionMessage_needsResponse$_get_serializer_$ref_uhp5m1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemCompletionMessage_needsResponse$_get_annotations_$ref_5qi1rv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemCompletionMessage_needsResponse', VOID, VOID, [SerializableProperty()]);
    LineItemCompletionMessage_needsResponseClass = $;
  }
  return LineItemCompletionMessage_needsResponseClass;
}
var LineItemCompletionMessage_needsResponse_instance;
function LineItemCompletionMessage_needsResponse_getInstance() {
  if (LineItemCompletionMessage_needsResponse_instance === VOID)
    new (LineItemCompletionMessage_needsResponse())();
  return LineItemCompletionMessage_needsResponse_instance;
}
//region block: exports
export {
  get_created as get_created2khbw6a16fbfp,
  get_lineItem as get_lineItem36mnygy89sqfj,
  prepareLineItemCompletionMessageFields as prepareLineItemCompletionMessageFields1z4f3fy1nqpg,
  get_project as get_project2hdo06n9xkkoa,
};
//endregion

//# sourceMappingURL=LineItemCompletionMessageFields.mjs.map
